import { ShieldCheck, Package } from 'lucide-react';

const initials = (n) => (n || '?').split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join('').toUpperCase();

// Live "How your listing will look" - mirrors the directory supplier + product cards.
export default function ListingPreview({ f }) {
  const logo = f.logo[0];
  const shots = f.screenshots;
  return (
    <div className="space-y-3" data-testid="listing-preview">
      <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider">How your listing will look</p>
      <div className="bg-white border border-[#E5E7EB] rounded-lg overflow-hidden shadow-sm" data-testid="preview-supplier-card">
        <div className="p-5">
          <div className="flex items-start justify-between mb-3 gap-2">
            {logo ? <img src={logo} alt="" className="h-9 w-auto max-w-[140px] object-contain" />
              : <span className="h-9 w-9 rounded-md bg-[#1A3A5F] text-[#ffffff] text-sm font-bold flex items-center justify-center">{initials(f.company_name)}</span>}
            <span className="inline-flex items-center gap-1 text-[10px] font-semibold text-[#ffffff] bg-[#1A3A5F] px-2 py-0.5 rounded-full"><ShieldCheck className="w-3 h-3" /> Confirmed</span>
          </div>
          <h3 className="font-semibold text-gray-900" data-testid="preview-name">{f.company_name || 'Your company name'}</h3>
          <p className="text-sm text-gray-500 mt-1 line-clamp-2" data-testid="preview-tagline">{f.tagline || f.description || 'Your tagline appears here'}</p>
          <div className="flex flex-wrap gap-1 mt-3">
            {(f.categories.length ? f.categories : ['Category']).map((c) => <span key={c} className="text-[11px] text-gray-600 bg-gray-100 px-2 py-0.5 rounded">{c}</span>)}
            <span className="text-[11px] text-[#00A79D] bg-[#00A79D]/5 px-2 py-0.5 rounded">1 product</span>
          </div>
          {f.care_types.length > 0 && (
            <div className="flex flex-wrap gap-1 mt-1.5">
              {f.care_types.map((c) => <span key={c} className="text-[11px] font-medium text-indigo-700 bg-indigo-50 border border-indigo-100 px-2 py-0.5 rounded">{c}</span>)}
            </div>
          )}
        </div>
      </div>
      <div className="bg-white border border-[#E5E7EB] rounded-lg overflow-hidden shadow-sm" data-testid="preview-product-card">
        {shots[0] && <div className="aspect-video bg-[#F1F5F4] overflow-hidden"><img src={shots[0]} alt="" className="w-full h-full object-cover" /></div>}
        <div className="p-5">
          <span className="inline-flex items-center gap-1 text-[10px] font-semibold text-[#00857D] bg-[#00A79D]/10 px-2 py-0.5 rounded"><Package className="w-3 h-3" /> Product</span>
          <h3 className="font-semibold text-gray-900 mt-2" data-testid="preview-product-name">{f.product_name || 'Your product name'}</h3>
          <p className="text-xs text-gray-400">by {f.company_name || 'your company'}</p>
          <p className="text-sm text-gray-500 mt-1.5 line-clamp-3">{f.product_description || 'What your product does appears here.'}</p>
          {shots.length > 1 && (
            <div className="flex gap-1.5 mt-3">{shots.slice(1).map((u) => <img key={u} src={u} alt="" className="w-14 h-10 object-cover rounded border border-[#E5E7EB]" />)}</div>
          )}
        </div>
      </div>
      <p className="text-[11px] text-gray-400">You can add more products, videos, FAQs and rich content in your supplier portal after payment.</p>
    </div>
  );
}
